module.exports = __webpack_public_path__ + "static/media/covid-19-covidsafe-news.6658c2f9.jpg";